import Col from './col-TEMPLATE_VERSION'

export default Col
